import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { RenderField, RenderHiddenField } from '../../form';

const RenderRsvpQuestion = ({ question }) => (
  <li className="rsvp-question">
    <Field
      id={`edit-guest-group-${question.id}-id`}
      name={`rsvp_question_answers[${question.id}].rsvp_question_id`}
      type="hidden"
      component={RenderHiddenField}
    />
    <Field
      id={`edit-guest-group-${question.id}-answer`}
      name={`rsvp_question_answers[${question.id}].answer`}
      type="text"
      component={RenderField}
      label={question.question}
      className="rsvp-question-field"
    />
  </li>
);

RenderRsvpQuestion.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number,
    question: PropTypes.string
  }),
};

export default RenderRsvpQuestion;



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/RenderRsvpQuestion.jsx